var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41083 0.337784L11.6608 5.58778C12.0283 5.95528 11.7682 6.58353 11.2484 6.58353H10.6651V10.0835C10.6651 10.5477 10.4807 10.9928 10.1525 11.321C9.82433 11.6492 9.37921 11.8335 8.91508 11.8335H8.33175V7.7502C8.33177 7.30383 8.16123 6.87432 7.855 6.54955C7.54877 6.22478 7.13002 6.0293 6.68442 6.00312L6.58175 6.0002H5.41508C4.95095 6.0002 4.50583 6.18458 4.17765 6.51276C3.84946 6.84095 3.66508 7.28607 3.66508 7.7502V11.8335H3.08175C2.61762 11.8335 2.1725 11.6492 1.84431 11.321C1.51612 10.9928 1.33175 10.5477 1.33175 10.0835V6.58353H0.748415C0.229249 6.58353 -0.0315013 5.95528 0.335999 5.58778L5.586 0.337784C5.69539 0.228426 5.84374 0.166992 5.99842 0.166992C6.15309 0.166992 6.30144 0.228426 6.41083 0.337784ZM6.58175 7.16687C6.73646 7.16687 6.88483 7.22833 6.99423 7.33772C7.10362 7.44712 7.16508 7.59549 7.16508 7.7502V11.8335H4.83175V7.7502C4.83177 7.60732 4.88422 7.46942 4.97917 7.36265C5.07411 7.25588 5.20494 7.18767 5.34683 7.17095L5.41508 7.16687H6.58175Z",
    fill: "#FFAE56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalTempIcon);
export default __webpack_public_path__ + "static/media/InternalTempIcon.cdcf2034cbbcc3a113d963489ecd32d8.svg";
export { ForwardRef as ReactComponent };